import { AudiocallIcon, GroupAvatarIcon, VideocallIcon } from '@/assets/images';
import { ListTile } from '@/components';
import LastSeen from '@/features/chats/sub-features/last-seen/ui/components/LastSeen';
import { Username, UserProfile } from '@/features/users';
import { CALL_TYPE } from '@/shared/constants/callConstants';
import PropTypes from 'prop-types';
import { useChatHeader } from '../../viewmodels';

/**
 * Pure rendering component — zero business logic.
 * All logic (call dispatch, info panel, feature gates) from useChatHeader().
 */
function ChatHeader({ activeChatJid }) {
   const {
      chatId,
      isGroup,
      isLastSeenEnabled,
      handleOpenContactInfo,
      handleOneToOneCall,
      handleGroupCallClick,
      handleBack,
      isCallActive,
      isSidePanelOpen,
      showCalls,
   } = useChatHeader(activeChatJid);

   return (
      <ListTile
         as="div"
         className={`conversationChatHeader main-chat-header ${isSidePanelOpen ? 'side-panel-open' : ''}`}
         contentClassName="chat-header-content"
         dotStatus="online"
         showBack
         isTrailingClickable={false}
         onClick={handleOpenContactInfo}
         onBack={handleBack}
         avatar={
            <UserProfile
               userId={chatId}
               className="chat-avatar chat-avatar-fallback ct-flexCenter"
               defaultIcon={isGroup ? <GroupAvatarIcon /> : null}
            />
         }
         title={<Username userId={chatId} className="chat-name" />}
         subTitle={isLastSeenEnabled ? <LastSeen activeChatJid={activeChatJid} /> : null}
         trailing={
            <div className="ct-flex ct-aiCenter ct-gap18">
               {showCalls && (
                  <>
                     <button
                        className={`chat-action-btn ${isCallActive ? 'ct-disabled' : 'ct-cursor'} ct-flexCenter`}
                        aria-label="Video Call"
                        onClick={e => {
                           e.stopPropagation();
                           if (isGroup) {
                              handleGroupCallClick(CALL_TYPE.VIDEO);
                           } else {
                              handleOneToOneCall(CALL_TYPE.VIDEO);
                           }
                        }}
                     >
                        <i className="ct-icon ct-lg">
                           <VideocallIcon />
                        </i>
                     </button>
                     <button
                        className={`chat-action-btn ${isCallActive ? 'ct-disabled' : 'ct-cursor'} ct-flexCenter`}
                        aria-label="Audio Call"
                        onClick={e => {
                           e.stopPropagation();
                           if (isGroup) {
                              handleGroupCallClick(CALL_TYPE.AUDIO);
                           } else {
                              handleOneToOneCall(CALL_TYPE.AUDIO);
                           }
                        }}
                     >
                        <i className="ct-icon ct-lg">
                           <AudiocallIcon />
                        </i>
                     </button>
                  </>
               )}
            </div>
         }
      />
   );
}

ChatHeader.propTypes = {
   activeChatJid: PropTypes.string.isRequired,
};

export default ChatHeader;
